import React from "react";
import about3Img from "../../../assets/Images/about/about-3.JPG";

export const AboutUsBanner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
      
      {/* Background Image */}
    <div className="shi">
        <img
        src={about3Img}
        alt="About Us"
        className="absolute inset-0 w-full h-full object-cover"
      />
    </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">
        
        <h2 className="text-white text-2xl md:text-4xl font-semibold drop-shadow-lg">
          About Us
        </h2>

        <p className="text-gray-200 text-sm md:text-base mt-2 mb-6 max-w-xl leading-relaxed drop-shadow-md">
          We are committed to delivering high-quality products and innovative.
        </p>

      </div>
    </section>
  );
};